__turbopack_context__.v({
  "aiSwitch": "styles-module-scss-module__lnt0eW__aiSwitch",
  "credit": "styles-module-scss-module__lnt0eW__credit",
  "creditAmount": "styles-module-scss-module__lnt0eW__creditAmount",
  "creditIcon": "styles-module-scss-module__lnt0eW__creditIcon",
  "enter": "styles-module-scss-module__lnt0eW__enter",
  "exit": "styles-module-scss-module__lnt0eW__exit",
  "fade-in": "styles-module-scss-module__lnt0eW__fade-in",
  "fade-out": "styles-module-scss-module__lnt0eW__fade-out",
  "fade-out-80": "styles-module-scss-module__lnt0eW__fade-out-80",
  "infoIcon": "styles-module-scss-module__lnt0eW__infoIcon",
  "slide-in-from-bottom": "styles-module-scss-module__lnt0eW__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__lnt0eW__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__lnt0eW__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__lnt0eW__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__lnt0eW__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__lnt0eW__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__lnt0eW__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__lnt0eW__slide-out-to-top",
  "tooltip": "styles-module-scss-module__lnt0eW__tooltip",
  "tooltipIcon": "styles-module-scss-module__lnt0eW__tooltipIcon",
  "zoom-in": "styles-module-scss-module__lnt0eW__zoom-in",
  "zoom-out": "styles-module-scss-module__lnt0eW__zoom-out",
});
